import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import type { FC } from "react";
import { useState } from "react";
import AsyncLoadingButton from "../../../components/asyncLoadingButton/AsyncLoadingButton";
import CancelButton from "../../../components/cancelButton/CancelButton";
import LabelledCheckbox from "../../../components/labelledCheckbox/LabelledCheckbox";

interface Props {
  onUnlink: (copyPrices: boolean) => Promise<void>;
}

const UnlinkOptionPrices: FC<Props> = ({ onUnlink }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [copyPrices, setCopyPrices] = useState(false);
  return (
    <>
      <Button variant="outlined" color="secondary" onClick={() => setDialogOpen(true)}>
        Usuń przypisanie cennika
      </Button>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>Usuń przypisanie cennika</DialogTitle>
        <DialogContent>
          <LabelledCheckbox label="Kopiuj ceny z przypisanego cennika" checked={copyPrices} onChange={setCopyPrices} />
        </DialogContent>
        <DialogActions>
          <CancelButton onClick={() => setDialogOpen(false)} />
          <AsyncLoadingButton
            onClick={async () => {
              await onUnlink(copyPrices);
              setDialogOpen(false);
            }}
          >
            Usuń
          </AsyncLoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UnlinkOptionPrices;
